// Mock data for Rentzo Services

export const carListings = [
  {
    id: 'car-1',
    name: 'Honda City',
    category: 'Sedan',
    price: 2500,
    period: 'month',
    image: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7',
    features: ['AC', 'Music System', 'Power Steering'],
    available: true
  },
  {
    id: 'car-2',
    name: 'Maruti Swift',
    category: 'Hatchback',
    price: 2000,
    period: 'month',
    image: 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d',
    features: ['AC', 'Bluetooth', 'ABS'],
    available: true
  },
  {
    id: 'car-3',
    name: 'Toyota Fortuner',
    category: 'SUV',
    price: 4500,
    period: 'month',
    image: 'https://images.unsplash.com/photo-1519641471654-76ce0107ad1b',
    features: ['4WD', 'Leather Seats', 'Sunroof'],
    available: true
  },
  {
    id: 'car-4',
    name: 'Hyundai i20',
    category: 'Hatchback',
    price: 2200,
    period: 'month',
    image: 'https://images.unsplash.com/photo-1583121274602-3e2820c69888',
    features: ['AC', 'Power Windows', 'Central Lock'],
    available: true
  }
];

export const bikeListings = [
  {
    id: 'bike-1',
    name: 'Royal Enfield Classic 350',
    category: 'Cruiser',
    price: 800,
    period: 'month',
    image: 'https://images.unsplash.com/photo-1558981806-ec527fa84c39',
    features: ['350cc', 'Disc Brake', 'Electric Start'],
    available: true
  },
  {
    id: 'bike-2',
    name: 'Honda Activa',
    category: 'Scooter',
    price: 500,
    period: 'month',
    image: 'https://images.unsplash.com/photo-1568772585407-9361f9bf3a87',
    features: ['110cc', 'Good Mileage', 'Comfortable'],
    available: true
  },
  {
    id: 'bike-3',
    name: 'Yamaha R15',
    category: 'Sports',
    price: 1200,
    period: 'month',
    image: 'https://images.unsplash.com/photo-1449426468159-d96dbf08f19f',
    features: ['155cc', 'Racing Design', 'ABS'],
    available: true
  },
  {
    id: 'bike-4',
    name: 'Bajaj Pulsar',
    category: 'Commuter',
    price: 700,
    period: 'month',
    image: 'https://images.unsplash.com/photo-1542282088-fe8426682b8f',
    features: ['150cc', 'Fuel Efficient', 'Sporty Look'],
    available: true
  }
];

export const applianceListings = [
  {
    id: 'appliance-1',
    name: 'Samsung Refrigerator',
    category: 'Refrigerator',
    price: 600,
    period: 'month',
    image: 'https://images.unsplash.com/photo-1571175443880-49e1d25b2bc5',
    features: ['300L', 'Double Door', 'Energy Efficient'],
    available: true
  },
  {
    id: 'appliance-2',
    name: 'LG Washing Machine',
    category: 'Washing Machine',
    price: 500,
    period: 'month',
    image: 'https://images.unsplash.com/photo-1626806787461-102c1bfaaea1',
    features: ['7kg', 'Front Load', 'Auto Clean'],
    available: true
  },
  {
    id: 'appliance-3',
    name: 'Voltas AC 1.5 Ton',
    category: 'Air Conditioner',
    price: 700,
    period: 'month',
    image: 'https://images.unsplash.com/photo-1585829365295-ab7cd400c167',
    features: ['1.5 Ton', 'Split AC', '3 Star'],
    available: true
  },
  {
    id: 'appliance-4',
    name: 'Microwave Oven',
    category: 'Microwave',
    price: 300,
    period: 'month',
    image: 'https://images.unsplash.com/photo-1585659722983-3a675dabf23d',
    features: ['20L', 'Convection', 'Auto Cook'],
    available: true
  }
];

export const pgListings = [
  {
    id: 'pg-1',
    name: 'Premium Single Room',
    category: 'Single Occupancy',
    price: 8000,
    period: 'month',
    image: 'https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af',
    features: ['AC', 'Attached Bathroom', 'WiFi', 'Meals Included'],
    available: true
  },
  {
    id: 'pg-2',
    name: 'Shared Double Room',
    category: 'Double Occupancy',
    price: 5000,
    period: 'month',
    image: 'https://images.unsplash.com/photo-1555854877-bab0e564b8d5',
    features: ['AC', 'Common Bathroom', 'WiFi', 'Meals Included'],
    available: true
  },
  {
    id: 'pg-3',
    name: 'Triple Sharing Room',
    category: 'Triple Occupancy',
    price: 4000,
    period: 'month',
    image: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304',
    features: ['Fan', 'Common Bathroom', 'WiFi', 'Meals Available'],
    available: true
  },
  {
    id: 'pg-4',
    name: 'Luxury Suite',
    category: 'Premium Suite',
    price: 12000,
    period: 'month',
    image: 'https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf',
    features: ['AC', 'Attached Bathroom', 'WiFi', 'All Meals', 'Housekeeping'],
    available: true
  }
];

export const heroImages = [
  {
    service: 'car',
    image: 'https://images.unsplash.com/photo-1565043666747-69f6646db940'
  },
  {
    service: 'bike',
    image: 'https://images.unsplash.com/photo-1455641374154-422f32e234cd'
  },
  {
    service: 'appliance',
    image: 'https://images.unsplash.com/photo-1484154218962-a197022b5858'
  },
  {
    service: 'pg',
    image: 'https://images.unsplash.com/photo-1709805619372-40de3f158e83'
  }
];
